import Component from '@glimmer/component';

export default class MwPageSidebarRight extends Component {}